<template>
  <div
    class="v-checkbox-select__wrapper"
    :class="{ [extraClass]: !!extraClass }"
  >
    <div class="title">
      <slot name="title"></slot>
    </div>

    <div class="items-wrapper" v-if="items && items.length">
      <div v-for="item in items" class="item">
        <VCheckbox
          v-if="flat"
          :name="item"
          :label="item"
          :checked="isKeyChecked(item)"
          @change="onChange(item)"
        />
        <VCheckbox
          v-else
          :name="item.key"
          :label="item.label"
          :checked="isKeyChecked(item.key)"
          @change="onChange(item.key)"
        />
      </div>
    </div>
    <div class="no-items" v-else>
      No items
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// components
import VCheckbox from "@/components/VCheckbox";

export default Vue.component("VCheckboxSelect", {
  props: {
    items: VueTypes.any,

    selectedKeys: VueTypes.arrayOf(VueTypes.string).def([]),

    // determining items structure
    // if flat it should be as array of string otherwise array of objects
    flat: VueTypes.bool.def(false),

    extraClass: VueTypes.string.def("")
  },

  components: {
    VCheckbox
  },

  methods: {
    isKeyChecked(key) {
      if (!this.selectedKeys) {
        return;
      }

      return this.selectedKeys.includes(key);
    },

    onChange(key) {
      this.$emit("oncheck", key);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-checkbox-select";

.#{$ns} {
  &__wrapper {
    height: 100%;

    .items-wrapper {
      height: calc(100% - 10px);
      max-height: 100%;
      overflow: auto;
      padding: 2px 25px 2px 0;

      /* width */
      &::-webkit-scrollbar {
        display: block;
        width: 7px;
        height: 8px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: $primary-grey;
        border: 3px solid transparent;
        background-clip: content-box;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #5757f5;
        border-radius: 3px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #5757f5;
      }
    }

    .item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      /deep/ .v-checkbox {
        label {
          display: inline-block;
          max-width: 130px;
          @include textCropEllipsis();
        }
      }

      /deep/ .v-checkbox__label {
        margin-left: 20px;
      }
    }

    &.empty {
      /deep/ .v-checkbox__box {
        &:after {
          border-color: $primary-color;
        }
      }
    }

    .no-items {
      padding: 4px 0;
      font-size: 14px;
      color: #1f1f1f;
    }
  }
}
</style>
